export default __webpack_public_path__ + "static/media/logo.e2cbb214.png";